import { render, staticRenderFns } from "./AssociatedProducts.vue?vue&type=template&id=71db50a2"
import script from "./AssociatedProducts.vue?vue&type=script&lang=js"
export * from "./AssociatedProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductSliderListItem: require('/app/components/ProductSliderListItem.vue').default})
